export class TenantOverride {
  tenantId: number;
  paymentTypeId: number;
  amount: number;
  month?: number;
  year?: number;
}
